import { Outlet } from 'react-router-dom';
import Navigation from '../Navigation.jsx';

export default function MainLayout() {
  return (
    <>
      <Navigation />
      <main role="main">
        <Outlet />
      </main>
      <footer className="pt-5 mt-5 text-center text-muted small">
        KitchenOS &copy; {new Date().getFullYear()} &middot; Blast Asia Inc
      </footer>
    </>
  );
}
